import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { InvestementTire, InvestementTireType, Rewards } from './rewards.model';

@Injectable({
  providedIn: 'root',
})
export class RewardsService {
  readonly rewards$: Observable<Rewards | null>;
  readonly investmentTires$: Observable<InvestementTire[] | null>;
  readonly isRewardsLoading$: Observable<boolean>;
  readonly isInvestmentTiresLoading$: Observable<boolean>;

  private readonly _rewards$: BehaviorSubject<Rewards | null> =
    new BehaviorSubject<Rewards | null>(null);
  private readonly _investmentTires$: BehaviorSubject<
    InvestementTire[] | null
  > = new BehaviorSubject<InvestementTire[] | null>(null);

  private readonly _isRewardsLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private readonly _isInvestmentTiresLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor() {
    this.rewards$ = this._rewards$.asObservable();
    this.investmentTires$ = this._investmentTires$.asObservable();
    this.isRewardsLoading$ = this._isRewardsLoading$.asObservable();
    this.isInvestmentTiresLoading$ =
      this._isInvestmentTiresLoading$.asObservable();
  }

  getRewards(): void {
    this._isRewardsLoading$.next(true);

    const rewards: Rewards = {
      totalRewardsEarned: 341.92,
      cashback: 131.0,
      referrals: 98.42,
      promotions: 112.5,
      investedIntheLast12Months: 2500,
      investedIntheLast12MonthsPercentage: 50,
      currentInvestementTire: InvestementTireType.INTRO,
      referLink: 'https://app.seedio.com/rewards?user=511asf13a31234asd14jk1',
      referEarnAmount: 100,
      referEarnAmountRequirement: 500,
    };

    setTimeout(() => {
      this._rewards$.next(rewards);
      this._isRewardsLoading$.next(false);
    }, 200);
  }

  getInvestmentTires(): void {
    this._isInvestmentTiresLoading$.next(true);

    const investmentTires: InvestementTire[] = [
      {
        type: InvestementTireType.INTRO,
        title: 'Intro',
        investToUnlock: 0,
        description: [
          'EUR 100 for every qualified referral',
          'No payment processing fees',
        ],
      },
      {
        type: InvestementTireType.PLUS,
        title: 'Plus',
        investToUnlock: 5000,
        description: [
          'EUR 200 for every qualified referral',
          '1% cashback on every investment for all investments',
        ],
      },
      {
        type: InvestementTireType.ELITE,
        title: 'Elite',
        investToUnlock: 25000,
        description: [
          'EUR 250 for every qualified referral',
          '2% cashback on every investment for all investments',
          'Elite welcome gift box',
        ],
      },
    ];

    setTimeout(() => {
      this._investmentTires$.next(investmentTires);
      this._isInvestmentTiresLoading$.next(false);
    }, 200);
  }
}
